import toastr from "toastr";

/**
 * Default parameters for toast notifications.
 */
export const InCoreToastDefault = {
    closeButton: false,
    debug: false,
    newestOnTop: true,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: false,
    onclick: undefined,
    showDuration: 300,
    hideDuration: 1000,
    timeOut: 4000,
    extendedTimeOut: 1000,
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    toastClass: ""
};

function objectToKeyValueArray(obj: Record<string, any>): { key: string; value: any }[] {
    return Object.entries(obj).map(([key, value]) => ({ key, value }));
}

/**
 * Types of toast notifications.
 */
export const InCoreToastType = {
    Success: "success",
    Error: "error",
    Warning: "warning",
    Info: "info",
    Notification: "notification"
};

/**
 * Positions for toast notifications.
 */
export const InCoreToastPosition = {
    TopRight: "toast-top-right",
    BottomRight: "toast-bottom-right",
    BottomLeft: "toast-bottom-left",
    TopLeft: "toast-top-left",
    TopFullWidth: "toast-top-full-width",
    BottomFullWidth: "toast-bottom-full-width",
    TopCenter: "toast-top-center",
    BottomCenter: "toast-bottom-center",
};

/**
 * Displays an advanced toast notification with custom parameters.
 * @param {string} type - The type of toast (e.g., success, error).
 * @param {string} message - The message to display.
 * @param {string | undefined} position - The position of the toast.
 * @param {number | undefined} timeout - The time before the toast automatically closes.
 * @param {string} title - The optional title to display
 */
export function InCoreToastX(
    type: string,
    message: string,
    position?: string,
    timeout?: number,
    title?: string
): void {
    const param: any = {};
    if (position) {
        param.positionClass = position;
    }
    if (timeout !== undefined) {
        param.timeOut = timeout;
    }
    InCoreToastCustom(type, message, param, title);
}

/**
 * Displays a standard toast notification 
 * @param {string} type - The type of toast (e.g., success, error).
 * @param {string} message - The message to display.
 */
export function InCoreToast(type: string, message: string): void {
    const param = { ...InCoreToastDefault };
    InCoreToastCustom(type, message, objectToKeyValueArray(param));
}

/**
 * Displays a standard toast notification, with title.
 * @param {string} type - The type of toast (e.g., success, error).
 * @param {string} title - The title to display.
 * @param {string} message - The message to display.
 */
export function InCoreToastT(type: string, title: string, message: string): void {
    const param = { ...InCoreToastDefault };
    InCoreToastCustom(type, message, objectToKeyValueArray(param), title);
}

/**
 * Displays a custom toast notification with overridden parameters.
 * @param {string} type - The type of toast (e.g., success, error).
 * @param {string} message - The message to display.
 * @param {object} delta - Parameters to override in the default configuration.
 * @param {string} title - The optional title to display
 */
export function InCoreToastCustom(type: string, message: string, delta: { key: string, value: any }[], title?: string): void {
    let messageOnly = `
        <div class='incore-flex-column-center' style='color: {COLOR};'>
            <span>{MESSAGE}</span>
        </div>
        `;
    let messageIcon = `
        <div class='incore-flex-row'>
           <div class='incore-flex-column-center'> 
               <i class='incore-mi-outlined' style='color: {COLOR}; padding-right: 12px;'>{ICON}</i> 
           </div> 
           <div class='incore-flex-column-center' style='color: {COLOR};'> 
               <span>{MESSAGE}</span> 
           </div> 
        </div>
        `;
    let messageTitle = `
        <div class='incore-flex-column-center' style='color: {COLOR};'>
           <span style='font-weight: 600; margin-bottom: 5px;'>{TITLE}</span>
           <span>{MESSAGE}</span>
        </div>
        `;
    let messageIconTitle = `
        <div class='incore-flex-row'>
           <div class='incore-flex-column-center'>
               <i class='incore-mi-outlined' style='color: {COLOR}; padding-right: 12px;'>{ICON}</i>
           </div>
           <div class='incore-flex-column-center-h' style='color: {COLOR};'>
               <span style='font-weight: 600; margin-bottom: 5px;'>{TITLE}</span>
               <span>{MESSAGE}</span>
           </div>
        </div>
        `;

    var myType = type;
    var myDelta: { key: string, value: any }[] = delta;
    var myTitle;
    if (title !== undefined) {
        myTitle = title;
    }
    else {
        myTitle = "";
    }
    var icon = "";
    var color = "";
    var myMessage = "";

    switch (myType) {
        case InCoreToastType.Success:
            icon = "check_circle";
            color = "var(--color-text-bianco)";
            break;

        case InCoreToastType.Error:
            icon = "error";
            color = "var(--color-text-bianco)";
            break;

        case InCoreToastType.Warning:
            icon = "warning";
            color = "var(--color-text-nero)";
            break;

        case InCoreToastType.Info:
            icon = "info";
            color = "var(--color-text-bianco)";
            break;

        case InCoreToastType.Notification:
            color = "var(--color-text-nero)";
            myType = InCoreToastType.Info;
            myDelta = [{ key: 'toastClass', value: 'toast toast-notification' }];
            break;
    }

    if (icon != "" && myTitle != "") {
        myMessage = messageIconTitle;
    }
    else if (icon != "" && myTitle == "") {
        myMessage = messageIcon;
    }
    else if (icon == "" && myTitle != "") {
        myMessage = messageTitle;
    }
    else {
        myMessage = messageOnly;
    }

    myMessage = myMessage.replace(/{MESSAGE}/g, message).replace(/{TITLE}/g, myTitle).replace(/{ICON}/g, icon).replace(/{COLOR}/g, color);

    const obj: any = { ...InCoreToastDefault, ...myDelta };
    console.log(myType);
    toastr.options = obj;
    toastr[myType as ToastrType](myMessage);
    //toastr.success(myMessage);
}